import { Component, input, output } from "@angular/core";
import { VdsIconButtonComponent } from "@cce/design-system/button";
import { VdsIconComponent } from "@cce/design-system/icon";
import { PolymorpheusContent, PolymorpheusOutlet } from "@taiga-ui/polymorpheus";

@Component({
    selector: "vds-main-nav",
    templateUrl: "./main-nav.component.html",
    styleUrl: "./main-nav.component.css",
    imports: [VdsIconComponent, VdsIconButtonComponent, PolymorpheusOutlet]
})
export class MainNavComponent {
    title = input<PolymorpheusContent<never> | undefined>(undefined);
    // eslint-disable-next-line @angular-eslint/no-output-native
    close = output<void>();
}
